import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import MessageBanner from '../shared/MessageBanner';
import { useUserInfo } from '../shared/UserInfo';
import { useAPIProgress } from '../shared/APIProgress';
import { callStrategiesGetAPI } from '../shared/APIHelper';
import { useStatusMessages } from '../shared/StatusMessages';
import { getLinkUri } from './StrategyUtils';

export default function StrategyLanding() {
  const info = useUserInfo();
  const { strategyId } = useParams();
  const tokenAvailable = info && info.token;
  const isAdmin = info && info.isAdmin;
  const hasCreateAccess = info && info.hasCreateAccess;
  const loggedInUser = info && info.userId;
  const [strategyInformation, setStrategyInformation] = useState(null);
  const { statusMessages, setStatusErrorMsg } = useStatusMessages();
  const navigate = useNavigate();
  const { apiInProgressCount, incrementAPIInProgress, decrementAPIInProgress } =
    useAPIProgress();

  useEffect(() => {
    if (tokenAvailable && strategyId > 0) {
      callStrategiesGetAPI(
        strategyId,
        incrementAPIInProgress,
        decrementAPIInProgress,
        setStatusErrorMsg,
        setStrategyInformation
      );
    }
  }, [strategyId, tokenAvailable]);

  useEffect(() => {
    if (strategyInformation) {
      let uri = getLinkUri(
        strategyInformation,
        loggedInUser.toUpperCase(),
        isAdmin,
        hasCreateAccess
      );
      navigate({
        pathname: uri,
        state: {
          strategy: strategyInformation
        }
      });
    }
  }, [strategyInformation]);

  return (
    !strategyInformation &&
    statusMessages &&
    statusMessages.error && (
      <MessageBanner
        statusMessages={statusMessages}
        apiInProgressCount={apiInProgressCount}
      />
    )
  );
}
